(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("linkify", [], factory);
	else if(typeof exports === 'object')
		exports["linkify"] = factory();
	else
		root["playkit"] = root["playkit"] || {}, root["playkit"]["contrib"] = root["playkit"]["contrib"] || {}, root["playkit"]["contrib"]["linkify"] = factory();
})(window, function() {
return 